import React, { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// actions
import { changeSidebarFilterType, changeSidebarType } from '../../redux/actions';

//constants
import { SideBarFilterTypes, SideBarTypes } from '../../constants/layout';

// store
import { RootState, AppDispatch } from '../../redux/store';

// helpers
import { findAllParent, findMenuItem, getTwoColumnMenuItems } from '../../helpers/menu';

// components
import IconMenu from './IconMenu';
import MainMenu from './MainMenu';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { useGetMenuTreeMenuListQuery } from '../../frameWork/rest/menu';
import { defaultEmptyGuid } from '../../constants/defaultValues';
import FilterItemsDashboard from './FilterItemsDashboard';
import LeftSidebarLever from './LeftSidebarLever';
import { Layout, Tabs } from 'antd';
import {  BsSliders2, BsList } from "react-icons/bs";

interface Item {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    badge?: {
        variant: string;
        text: string;
    };
    parentKey?: string;
    target?: string;
    children?: Item[];
}

const LeftSidebar = ({ openLeftMenuCallBack, isMenuOpened }: any) => {

    const location = useLocation();
    const { isLoading: isLoading, data: menuItems, refetch: getAllMenuTreeList } = useGetMenuTreeMenuListQuery([API_ENDPOINTS.MENU_TREEMENU, defaultEmptyGuid], defaultEmptyGuid);
    const dispatch = useDispatch<AppDispatch>();    

    const [activeMenuItems, setActiveMenuItems] = useState<Array<string>>([]);

    const { isSlideShow } = useSelector((state: any) => state.DashboardPage);
    const { leftSideBarType, leftSideBarFilterType } = useSelector((state: RootState) => ({
        leftSideBarType: state.Layout.leftSideBarType,
        leftSideBarFilterType: state.Layout.leftSideBarFilterType,

    }));



    /*
     * toggle the menus
     */
    const toggleMenu = (menuItem: any, show: boolean) => {             
        if (menuItem.children) {           
            if (leftSideBarType === 'condensed') dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
            if (leftSideBarFilterType === 'default') dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));
        }

        if (show) setActiveMenuItems([menuItem['key'], ...findAllParent(menuItems, menuItem)]);
    };

    /**
     * activate the menuitems
     */

    const activeMenu = useCallback(() => {
        const div = document.getElementById('sidebar-content');
        let matchingMenuItem = null;
    
        if (div) {
            // بررسی منوهای فرزند (Child Menus)
            let items: any = div.getElementsByClassName('nav-link-ref');
                                        
            for (let i = 0; i < items.length; ++i) {                                            
                if (location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
    
            // اگر منوی فرزند پیدا شد
            if (matchingMenuItem) {              
                const mid = matchingMenuItem.getAttribute('data-menu-key');
                const activeMt = findMenuItem(menuItems, mid);
                if (activeMt) {
                    setActiveMenuItems([activeMt['key'], ...findAllParent(menuItems, activeMt)]);
                }
            } else {             
                let items: any = div.getElementsByClassName('ehsan');              

            for (let i = 0; i < items.length; ++i) {
                if (location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }           
            if (matchingMenuItem) {
                const mid = matchingMenuItem.getAttribute('data-menu-key');
                const activeMt = findMenuItem(menuItems, mid);
                if (activeMt) {
                    setActiveMenuItems([activeMt['key'], ...findAllParent(menuItems, activeMt)]);
                }
            }                
                // // اگر منوی فرزند پیدا نشد، منوهای پدر را بررسی کن
                // const activeParent = menuItems?.find((menuItem:any) =>
                //     menuItem?.children?.some((child:any) =>
                //      location.pathname.includes(`/dashboard/dashboardPage/${child.key}`)
                //      )
                // );
                    
                // if (activeParent) {
                //     setActiveMenuItems([activeParent['key'], ...findAllParent(menuItems, activeParent)]);
                // }
            }
        }
    }, [location, menuItems]);

    // const activeMenu = useCallback(() => {       
    //     const div = document.getElementById('sidebar-content');
    //     let matchingMenuItem = null;

    //     if (div) {
    //         let items: any = div.getElementsByClassName('nav-link-ref');
    //         for (let i = 0; i < items.length; ++i) {

    //             if (location.pathname === items[i].pathname) {
    //                 matchingMenuItem = items[i];
    //                 break;
    //             }
    //         }
    //         if (matchingMenuItem) {
    //             const mid = matchingMenuItem.getAttribute('data-menu-key');
    //             const activeMt = findMenuItem(menuItems, mid);
    //             if (activeMt) {
    //                 setActiveMenuItems([activeMt['key'], ...findAllParent(menuItems, activeMt)]);
    //             }
    //         }            
    //     }
    // }, [location, menuItems]);

    useEffect(() => {
        activeMenu();
    }, [activeMenu]);
    
    useEffect(() => {
        getAllMenuTreeList();
    }, [])   

    const openMenuFromLeftSidebarLever = () => {
        if (openLeftMenuCallBack) openLeftMenuCallBack()
    }

    const { Header, Content, Sider, Footer } = Layout;
    const onChange = (key: string) => {
        switch (key) {
            case "1":
                dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
                dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));
                break;

            case "2":
                dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
                dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_DEFAULT));
                break;
        }
    };
    return (
        <>
            <div className="left-side-menu">
                <div className="h-100">
                    <div className="sidebar-content" id="sidebar-content">
                        <IconMenu
                            menuItems={menuItems}
                            toggleMenu={toggleMenu}
                            activeMenuItems={activeMenuItems}
                        />
                        <div className="sidebar-main-menu-tab">
                            
                            {location.pathname.indexOf('/dashboard/publicdashboardPage') === -1 &&  !isSlideShow ?
                            <Tabs activeKey={(leftSideBarType.toString().trim() == 'default' && leftSideBarFilterType.toString().trim() == 'default') ? "2" : "1"} onChange={onChange} items={[
                                {
                                    key: '1',
                                    label: <BsList className="sanjabMenuIcon" style={{ fontSize: 20, width: 94 }} />,
                                    children: <MainMenu menuItems={menuItems} activeMenuItems={activeMenuItems} toggleMenu={toggleMenu} />,                                                                       
                                },
                                {
                                    key: '2',
                                    label: <BsSliders2 className="sanjabMenuIcon" style={{ fontSize: 18, width: 94 }} />,
                                    children: <FilterItemsDashboard />,
                                    disabled: location.pathname.indexOf('/dashboard/dashboardPage') === -1  && location.pathname.indexOf('/dashboard/publicdashboardPage') === -1
                                }
                            ]} ></Tabs>
                            :
                            <FilterItemsDashboard />
                        }                                                            
                        </div>                       
                        <LeftSidebarLever openLeftMenuCallBack={openMenuFromLeftSidebarLever} isMenuOpened={isMenuOpened} />
                    </div>

                    <div className="clearfix" />
                </div>
            </div>
        </>
    );
};

export default React.memo(LeftSidebar);
